import { useContext, createContext } from 'react';

const DiagnosticFormContext = createContext();

export const useDiagnosticForm = () => useContext(DiagnosticFormContext);

export default DiagnosticFormContext;
